const normalizeIconKey = (value) => String(value ?? "").trim().toLowerCase();

const isGeneratedMarketplaceIconKey = (iconKey) => {
  const normalizedIconKey = normalizeIconKey(iconKey);
  return normalizedIconKey.startsWith("marketplaceproduct")
    || normalizedIconKey.startsWith("marketplaceresource");
};

const isSvgIconPath = (iconPath) => /\.svg(?:[?#].*)?$/i.test(String(iconPath ?? "").trim());

export const shouldRenderResourceWorkspaceIconAsImage = ({ iconKey, iconPath, preferImage = false }) =>
  Boolean(iconPath) && (preferImage || isGeneratedMarketplaceIconKey(iconKey) || isSvgIconPath(iconPath));
